import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import QQButton from "./Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Notification(props) {
  const handleClose = () => {
    props.hideNotificationDialog();
  };

  return (
    <div>
      <Dialog
        open={props.open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          <span>
            <FontAwesomeIcon icon="fa-solid fa-bell" />
          </span>{" "}
          &nbsp;Update
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {props.notificationMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <QQButton onClick={handleClose} btnText="Ok" floatRight />
        </DialogActions>
      </Dialog>
    </div>
  );
}
